import React, { useEffect, useState } from 'react'
import AdvertiserTotals from '../../adv/campaign/campaign/CampaignTotals'
import { mixpanelInstance } from '../../mixpanel/instance'
import { useCookiesContext } from '../../contexts/CookiesContext'
import { Row } from 'react-bootstrap'
import '../loader.css'
import { addBgOnIframe, loadDateRange } from '@revbox/helpers-fe'
import { addDays, endOfDay, startOfDay } from 'date-fns'

export default function AdverticerTotalsIframe() {
    const { cookiesData, getPathKey } = useCookiesContext()

    const [iframe, setIframe] = useState(null)
    const [campaignId, setCampaignId] = useState(null)
    const [currentPeriod, setCurrentPeriod] = useState(null)
    const [previousPeriod, setPreviousPeriod] = useState(null)

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search)
        const token = urlParams.get('token');
        const store = cookiesData[getPathKey()]
        const { currentPeriod, previousPeriod } = loadDateRange(token, store, startOfDay, endOfDay, addDays)
        if (currentPeriod && previousPeriod) {
            setCurrentPeriod(currentPeriod)
            setPreviousPeriod(previousPeriod)
        }
        const campaignId = urlParams.get('campaignId')
        setCampaignId(campaignId)
        mixpanelInstance.track('Advertiser Totals Page Loaded')
        addBgOnIframe();
        setIframe(1)
    }, [])

    if (iframe === 1 && currentPeriod && previousPeriod) {
        return (
            <Row className="g-3 htr-iframe-bg" style={{ width: '100%', margin: '0 auto' }}>
                <AdvertiserTotals isIframe={true} campaignId={campaignId} currentPeriod={currentPeriod} previousPeriod={previousPeriod} />
            </Row>
        )
    } else {
        return (
            <div>
                <span className="loader"></span>
            </div>
        )
    }
}
